import { ApiClient } from "#/shared/api/client";

export class BaseDecisionTreeViewerApi extends ApiClient {
  constructor(options) {
    super({ api: "decision_tree", ...options });
  }
}
